export default {
  'categories.shoes': 'Chaussures',
  'categories.hoodies': 'Hoodies et pulls',
  'categories.tshirts': 'T-shirts',
  'categories.jackets': 'Vestes',
  'categories.pants': 'Pantalons et shorts',
  'categories.headwear': 'Couvre-chefs',
  'categories.sets': 'Ensembles',
  'categories.underwear': 'Sous-vêtements',
  'categories.jersey': 'Maillot',
  'categories.accessories': 'Accessoires',
  'categories.bags': 'Sacs',
  'categories.belts': 'Ceintures',
  'categories.perfumes': 'Parfums',
  'categories.other': 'Autres articles',

  'nav.guides': 'Guides',
  'nav.categories': 'Catégories',
  'nav.shipping': 'Livraison',
  'nav.warehouse': 'Entrepôt',
  'nav.coupons': 'Coupons',
  'nav.safety': 'Sécurité',
  'nav.buyNow': 'Acheter maintenant',
  'nav.home': 'Accueil',
  'nav.shoppingGuide': 'Guide d\'achat',
  'nav.about': 'À propos',

  'hero.eyebrow': 'CENTRE DE RESSOURCES USFANS SPREADSHEET',
  'hero.title': 'USFans Spreadsheet — trouvez, comparez et explorez les ressources plus vite',
  'hero.subtitle': 'Explorez les ressources USFans spreadsheet, les guides de recherche de produits, les avis, les informations de livraison, les guides d\'entrepôt, les coupons, les conseils de sécurité et les tutoriels pratiques — tout au même endroit.',
  'hero.ctaPrimary': 'Explorer USFans Spreadsheet',
  'hero.ctaSecondary': 'Voir les guides USFans',
  'hero.searchPlaceholder': 'Recherchez des feuilles de calcul, produits, vendeurs ou guides...',
  'hero.trust': 'Ressource indépendante • Guides pratiques • Mise à jour régulière',

  'trust.1.title': 'USFans Spreadsheet',
  'trust.1.desc': 'Des ressources organisées et des informations pratiques.',
  'trust.2.title': 'Recherche de produits',
  'trust.2.desc': 'Comparez produits, vendeurs et ressources utiles.',
  'trust.3.title': 'Livraison et entrepôt',
  'trust.3.desc': 'Comprenez la livraison, l\'entrepôt et la préparation.',
  'trust.4.title': 'La sécurité d\'abord',
  'trust.4.desc': 'Vérifiez liens, vendeurs, prix et paiements.',

  'category.title': 'Parcourir les catégories de produits',
  'category.subtitle': 'Accédez directement à n\'importe quelle catégorie du site principal.',
  'category.dropdownLabel': 'Choisir une catégorie',
  'category.dropdownPlaceholder': 'Sélectionnez une catégorie pour continuer...',

  'about.title': 'Qu\'est-ce qu\'une USFans Spreadsheet ?',
  'about.copy': 'Une USFans spreadsheet est une ressource structurée utilisée pour organiser les informations sur les produits, les liens, les vendeurs, les catégories et les recherches d\'achat associées. Notre objectif est de rendre ces informations plus faciles à découvrir, comprendre et comparer.',
  'about.cta': 'Découvrez comment fonctionnent les feuilles USFans',

  'explore.title': 'Votre centre de recherche USFans Spreadsheet',
  'explore.subtitle': 'Tout est organisé au même endroit, de la recherche à la sécurité.',
  'explore.1.title': 'USFans Spreadsheet',
  'explore.2.title': 'Recherche de produits',
  'explore.3.title': 'Ressources vendeurs',
  'explore.4.title': 'Avis',
  'explore.5.title': 'Livraison',
  'explore.6.title': 'Entrepôt',
  'explore.7.title': 'Coupons',
  'explore.8.title': 'Sécurité',

  'guides.title': 'Guides USFans populaires',
  'guides.subtitle': 'Des guides pratiques et originaux pour vous aider à mieux décider.',
  'guides.readMore': 'Lire le guide',

  'pillars.eyebrow': 'Guides piliers',
  'pillars.title': 'Guides piliers USFans Spreadsheet',
  'pillars.subtitle': 'Des articles originaux et approfondis sur les sujets essentiels — des bases à la recherche, aux produits, vendeurs et comparaisons.',

  'module.review.title': 'Avis USFans',
  'module.review.desc': 'Ce qu\'il faut savoir avant de l\'utiliser : fonctions, livraison, entrepôt et paiement.',
  'module.shipping.title': 'Guide des frais de livraison',
  'module.shipping.desc': 'Comment le poids, la destination et la méthode influent sur le coût.',
  'module.coupon.title': 'Coupon et code promo',
  'module.coupon.desc': 'Comment fonctionnent les coupons et où vérifier les promotions en cours.',
  'module.warehouse.title': 'Guide de l\'entrepôt',
  'module.warehouse.desc': 'Stockage, inspection, regroupement et emballage expliqués.',
  'module.safety.title': 'USFans est-il fiable ?',
  'module.safety.desc': 'Une liste pratique pour vérifier liens, vendeurs et paiements.',

  'cta.title': 'Prêt à explorer les ressources USFans Spreadsheet ?',
  'cta.text': 'Commencez par le centre USFans Spreadsheet, explorez des guides et comparaisons pratiques, puis continuez vers le site principal quand vous voulez en savoir plus.',
  'cta.primary': 'Explorer USFans Spreadsheet',
  'cta.secondary': 'Visiter le site principal',

  'footer.tagline': 'Un centre de ressources indépendant sur USFans Spreadsheet.',
  'footer.resources': 'Ressources',
  'footer.company': 'Entreprise',
  'footer.legal': 'Mentions légales',
  'footer.languages': 'Langues',
  'footer.disclaimer': 'Ce site est une ressource informative indépendante et n\'est pas nécessairement affilié ni approuvé par USFans, sauf indication explicite.',
};